module.exports = "/images/zink-logo-text-positive.png?5ab176d5bc346904a2dfe2270aa096cb";